<div [style.width]="convertPxToRem(size)" [style.height]="convertPxToRem(size)" class="ma-svg-icon">
  <i nz-icon  [innerHTML]="svgIcon" *ngIf="!isUrl"></i>
  <i class="icon" *ngIf="isUrl" [style.content]="contentUrl"></i>
</div>
